import React, {FC} from "react";
import routes, {getRoute} from "~/route-map";
import {getActiveTab} from "~/utils/nav-utils";
import TnTabbedNavbar from "@touchnet/react-tabbed-navbar";
import {Route, Routes} from 'react-router-dom';
import UserMgmtUsersPage from "~/components/pages/user-mgmt/user-mgmt-users-page";
import UserMgmtRolesPage from "~/components/pages/user-mgmt/roles/user-mgmt-roles-page";
import {useSelector} from "react-redux";
import Selectors from "~/state/selectors.ts";

export const UserMgmtPage: FC = () => {
    const cnum = useSelector(Selectors.getCustomerNumber);
    const ctx = useSelector(Selectors.getAppContext);

    const activeTab = getActiveTab(
        location.pathname,
        /\/admin\/users(?:\/(?<tabId>[-a-z]+))?/iu,
        'users'
    );

    const pageTabs = [
        {
            id: 'users',
            href: getRoute(routes.users.base, {cnum, ctx}),
            label: 'Users',
        },
        {
            id: 'roles',
            href: getRoute(routes.users.roles.base, {cnum, ctx}),
            label: 'Roles'
        },
    ];

    return (
        <div className="d-flex flex-column h-100">
            <h2>User Management</h2>
            <TnTabbedNavbar activeTab={activeTab} tabs={pageTabs}/>
            <div className="pt-3 flex-grow-1 d-flex flex-column overflow-auto">
                <Routes>
                    <Route
                        path={`/`}
                        element={<UserMgmtUsersPage />}
                    />
                    <Route
                        path={`/roles`}
                        element={<UserMgmtRolesPage />}
                    />
                </Routes>
            </div>
        </div>
    );
}

export default UserMgmtPage;
